import api from './api'

export const paperTradingService = {
  list: () => api.get('/paper-trading/'),
  create: (data) => api.post('/paper-trading/', data),
  get: (id) => api.get(`/paper-trading/${id}`),
  update: (id, data) => api.patch(`/paper-trading/${id}`, data),
  delete: (id) => api.delete(`/paper-trading/${id}`),
  // D10 (F4 paquete paper): con posiciones abiertas el backend responde 409
  // y el reset exige confirmOpenPositions=true (no bloquea, avisa).
  reset: (id, confirmOpenPositions = false) => api.post(
    `/paper-trading/${id}/reset`, null,
    confirmOpenPositions ? { params: { confirm_open_positions: true } } : undefined,
  ),
  getBalance: (id) => api.get(`/paper-trading/${id}/balance`),
}
